import React, { forwardRef } from 'react';
import BillingSection from '../../../components/PatientDetails/BillingSection/BillingSection';
// import BlankPage from '../../../components/PatientDetails/BlankPage';
// import ClinicalInfo from '../../../components/PatientDetails/ClinicalInfo/ClinicalInfo';
import NewPatient from '../../../components/PatientDetails/NewPatient/NewPatient';
// import PrescriptionSection from '../../../components/PatientDetails/PrescriptionSection/PrescriptionSection';
// import TreatmentHistory from '../../../components/PatientDetails/TreatmentHistory/TreatmentHistory';


const PatientDetails = forwardRef((props, ref) => {
  
    // const childRef = useRef();
    
    return (
        <div>
            
            <section>
                <NewPatient ref={ref}></NewPatient>
            </section>
            {/* <section>
                <ClinicalInfo></ClinicalInfo>
            </section>
            <section>
                <TreatmentHistory></TreatmentHistory>
            </section>
            <section>
                <PrescriptionSection></PrescriptionSection>
            </section> */}
            <section>
                <BillingSection ref={ref}></BillingSection>
            </section>
            {/* <section>
                <BlankPage></BlankPage>
            </section> */}

        </div>
    );
});

export default PatientDetails;